/**
 * @generated SignedSource<<d5659272f17392486f986f1dba469397>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Pagination$data = {
  readonly totalCount: number | null | undefined;
  readonly " $fragmentType": "Pagination";
};
export type Pagination$key = {
  readonly " $data"?: Pagination$data;
  readonly " $fragmentSpreads": FragmentRefs<"Pagination">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Pagination",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalCount"
    }
  ],
  "type": "HasTotal",
  "abstractKey": "__isHasTotal"
};

(node as any).hash = "381e01f35c5de38328f9fdecc8742b34";

export default node;
